<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/user-management/user/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Users List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container> User
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertUserFrom"
    (ngSubmit)="onUpsertUser()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <div class="row">
            <div *appHasPlatformAccess class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onUserTypeSelected($event)"
                [inputData]="attrConstant.userType"
                [selectOptions]="roleType"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [formControlName]="
                  attrConstant.userType.key
                "></app-input-select>
            </div>
            <div *appHasPlatformAccess class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.partner"
                [selectOptions]="partnerList | async"
                [bindLabel]="'name'"
                [bindValue]="'partner_id'"
                [formControlName]="attrConstant.partner.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.firstName"
                [formControlName]="
                  attrConstant.firstName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.lastName"
                [formControlName]="
                  attrConstant.lastName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onNationalitySelected($event)"
                [inputData]="attrConstant.nationality"
                [selectOptions]="countryList | async"
                [bindLabel]="'country_name'"
                [bindValue]="'alpha3'"
                [formControlName]="
                  attrConstant.nationality.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-datepicker
                [inputData]="attrConstant.dob"
                [formControlName]="attrConstant.dob.key"></app-input-datepicker>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.email"
                [formControlName]="attrConstant.email.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.gender"
                [selectOptions]="gender"
                [bindLabel]="'name'"
                [bindValue]="'value'"
                [formControlName]="attrConstant.gender.key"></app-input-select>
            </div>
            <div class="col-md-1 col-2 form-group">
              <app-input-template
                [inputData]="attrConstant.countryCode"
                [formControlName]="
                  attrConstant.countryCode.key
                "></app-input-template>
            </div>
            <div class="col-md-5 col-10 form-group ps-0">
              <app-input-template
                [inputData]="attrConstant.mobileNumber"
                [formControlName]="
                  attrConstant.mobileNumber.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.roleId"
                [selectOptions]="roleList"
                [bindLabel]="'name_description'"
                [bindValue]="'role_id'"
                [formControlName]="attrConstant.roleId.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                (passwordChanged)="patchPassword($event)"
                [inputData]="attrConstant.password"
                [formControlName]="
                  attrConstant.password.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.address1"
                [formControlName]="
                  attrConstant.address1.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.address2"
                [formControlName]="
                  attrConstant.address2.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.city"
                [formControlName]="attrConstant.city.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.postalCode"
                [formControlName]="
                  attrConstant.postalCode.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group d-flex align-items-center">
              <mat-label [id]="attrConstant.isMFADisabled.key">
                {{ attrConstant.isMFADisabled.label }}
              </mat-label>
              <mat-radio-group
                [attr.aria-labelledby]="attrConstant.isMFADisabled.key"
                [formControlName]="attrConstant.isMFADisabled.key">
                <mat-radio-button
                  class="ms-4"
                  *ngFor="let data of booleanOption"
                  [value]="data.value">
                  {{ data.viewValue }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
